/* eslint-disable testing-library/no-debugging-utils */
import * as Sentry from '@sentry/react'
import { Logger } from '@egw/logger'
import { notifications, NOTIFICATIONS } from '@egw/notifications'
import { fullStoryIntegration } from '@sentry/fullstory'
import { FullStory } from '@fullstory/browser'
import { type Config } from '../../config/config'

const log = new Logger('Monitoring Service - Sentry')

let instance: MonitoringService | null = null

class MonitoringService {
  private orgSlug?: string

  constructor() {
    if (!instance) {
      instance = this

      // Notifications linsteners
      const loggerErrorHandler = (data: unknown): void => {
        const logs = (data as { detail: unknown }).detail
        Sentry.captureException(JSON.stringify(logs))
      }
      notifications.on(NOTIFICATIONS.LOGGER.ERROR, loggerErrorHandler)

      const fullStoryInitHandler = (): void => {
        // Add Sentry FullStory integration
        Sentry.addIntegration(
          fullStoryIntegration(this.orgSlug ?? '', {
            client: FullStory,
          }),
        )
        log.debug('FullStory integration is added to Sentry')
      }
      notifications.on(NOTIFICATIONS.FULLSTORY.INIT, fullStoryInitHandler)
    }
  }

  init = (config: Config): void => {
    if (typeof config.sentry === 'undefined') {
      log.error('Sentry configuration is missing')
      throw new Error('Sentry configuration is required')
    }
    this.orgSlug = config.sentry.orgSlug
    Sentry.init({
      release: `v${config.appVersion}`,
      enabled: true,
      dsn: config.sentry.dsn,
      environment: config.sentry.environment,
      tracesSampleRate: 1.0,
      profilesSampleRate: 1.0,
      integrations: [Sentry.browserProfilingIntegration()],
      debug: false, // Setting this option to true will print useful information to the console while setting up Sentry
      // replaysSessionSampleRate: 0.1,
      // replaysOnErrorSampleRate: 1.0,
      // tracePropagationTargets: [/^https:\/\/app.wealth-eg-dev\.com/, 'https://app.wealth-eg-dev.com'],
    })
    log.info('Sentry is initialized')
  }
}

export const monitoringService = new MonitoringService()
